import _ from "lodash";
import { useEffect } from "react";

let routeSchedules = {
  MA: "Monday-A",
  MB: "Monday-B",
  TUA: "Tuesday-A",
  TUAN: "Tuesday-A",
  TUB: "Tuesday-B",
  TUBN: "Tuesday-B",
  WA: "Wednesday-A",
  WAN: "Wednesday-A",
  WB: "Wednesday-B",
  WBN: "Wednesday-B",
  THA: "Thursday-A",
  THAN: "Thursday-A",
  THB: "Thursday-B",
  THBN: "Thursday-B",
  FA: "Friday-A",
  FAN: "Friday-A",
  FB: "Friday-B",
  FBN: "Friday-B",
};

function BackToStart() {
  window.location.reload();
}

function ExitForm() {
  window.close();
}


function convertDateFormat(dateStr) {
    if (typeof dateStr !== "string") return null;

    const parts = dateStr.split("/");
    if (parts.length !== 3) return null;

    const [day, month, year] = parts.map(Number);

    // Validate date parts
    if (
        !Number.isInteger(day) || !Number.isInteger(month) || !Number.isInteger(year) ||
        day < 1 || day > 31 || month < 1 || month > 12
    ) {
        return null;
    }

    // Create Date object (month is 0-based in JS)
    const date = new Date(year, month - 1, day);

    // Check if date is valid
    if (isNaN(date.getTime())) return null;

    // Format date: "Thursday 13 August 2026"
    const formatter = new Intl.DateTimeFormat("en-GB", {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric"
    });

    return formatter.format(date).replace(",","");
}


function MakeCollectionsPretty(allBins) {
  let bins = allBins.split(",");

  let prettyBins = (
    <>
      {Object.entries(bins).map(([key, value]) => {
        return (
          <>
            {value.trim() == "Recycling" && (
              <span className="bin-entry" style={{ color: "green" }}>
                Recycling&nbsp;<i class="fa fa-recycle"></i>
              </span>
            )}
            {value.trim() == "food bin" && (
              <span className="bin-entry" style={{ color: "green" }}>
                Food&nbsp;<i class="fa fa-utensils"></i>
              </span>
            )}
            {value.trim() == "black bin" && (
              <span className="bin-entry">
                Black&nbsp;<i class="fa fa-trash"></i>
              </span>
            )}
            {value.trim() == "garden waste" && (
              <span className="bin-entry" style={{ color: "green" }}>
                Garden&nbsp;<i class="fa fa-trash"></i>
              </span>
            )}
          </>
        );
      })}
    </>
  );

  return prettyBins;
}

function DateContainer({ children }) {
  return <div className="date-container">{children}</div>;
}

function NextDate({ collection }) {
  return (
    <div className="next-date" style={{ backgroundColor: collection.color }}>
      <p style={{ color: collection.textColor }} >{ UserFriendlyBinNames(collection.bin) }</p>
      <p style={{ color: collection.textColor }} className="next-date__date">{collection.date}</p>
    </div>
  );
}


function UserFriendlyBinNames(machineName){
  let userFriendlyName = "";
  switch(machineName) {
    case "Recycling":
      userFriendlyName = "Recycling";
      break;
    case "Refuse":
      userFriendlyName = "Black bin";
      break;
    case "Food":
      userFriendlyName = "Food bin";
      break;
    case "Garden":
      userFriendlyName = "Green bin";
      break;
    case "AHP":
      userFriendlyName = "Hygiene or nappy waste";
      break;
    case "Clinical":
      userFriendlyName = "Clinical";
      break;
    default:
      userFriendlyName = machineName;
    // code block
  }
  return userFriendlyName;
}


function orderBinCards(unorderedCards){
  let orderedCards = [];
  try{
    let order = ["Refuse","Food","Recycling","Garden", "AHP", "Clinical"]; // FOOD is left out as same as Recycling
    for(let i = 0; i < order.length; i++ ){
      let searchTerm = order[i];
      for(let j in unorderedCards){ 
        let itemObject = unorderedCards[j];
        if(itemObject != null && searchTerm === itemObject['bin']){   
            if(searchTerm === "AHP" ){
              console.log("AHP --> ", searchTerm, itemObject);
            }
            orderedCards.push(itemObject);
        } 
      }
    }
  }
  catch{
    orderedCards = unorderedCards;
  }
  return orderedCards;
}



function GWCollectionResults({
  GardenWasteSubs,
  collectionRetreived,
  prevFormStep,
  routeCode,
  collectionTypeDates,
}) {

  let routePDFURLNew = `https://hosted.southglos.gov.uk/ccalendars26/Calendar ${routeCode}.pdf`; 
  //let routePDFURLNew = `https://hosted.southglos.gov.uk/ccalendars/Calendar ${routeCode}.pdf`; 


  useEffect(() => {
    //console.log(collectionTypeDates);
  }, [collectionTypeDates]);
  return (
    <div>
      {collectionRetreived && (

        <>

          <a
            className=""
            style={{ textDecoration: "underline", cursor: "pointer" }}
            onClick={prevFormStep}
          >
            <svg
              style={{ transform: "rotate(180deg)" }}
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 14 14"
            >
              <g fill="none" fill-rule="evenodd">
                <path
                  fill="#00709E"
                  fill-rule="nonzero"
                  d="M8.371 7l-4.527 4.244a.955.955 0 0 0 .002 1.413c.42.393 1.09.391 1.506.002l5.284-4.954a.962.962 0 0 0 .311-.704.96.96 0 0 0-.311-.706L5.352 1.34a1.116 1.116 0 0 0-1.506.002.953.953 0 0 0-.002 1.413L8.37 7z"
                />
              </g>
            </svg>
            Back
          </a>
          <br/><br/>

          <p>Your next collections:</p>
          <DateContainer>
            {orderBinCards(collectionTypeDates).map((collectionType) => {
              if(collectionType !== null && !(collectionType.bin =="Garden" && routeCode == "INT")  ){
                return (
                  <NextDate
                    key={collectionType.bin}
                    collection={collectionType}
                  />
                );
              }
            })}
          </DateContainer>


          <div id="nextCollection">

            {/* <div
                class="wp-block-sgc-blocks-library-calltoaction-text wp-block-sgc-calltoaction-text"
                style={{ margin: "0 0 1rem 0", padding: "1rem 2rem" }}

              >
              <p
                style={{ margin: "0px" }}
              >
                Most people's recycling and bin collection days are changing from Monday 4 August 2025. You can view or print your collection calendar below.
              </p>
            </div> */}

            <p>Put your bins, boxes and bags out by 7am on your collection day.</p>

            <h2>Collection calendar</h2>

            {/* {routeCode == "FLAT"
              ? null
              :  <a
                  href={routePDFURL}
                  style={{ textDecoration: "underline" }}
                  target="_parent"
                >
                  View or print your collection calendar (up to 3 August 2025){" "}<br />
                </a>
            } */}


            {/* {routeCode == "FLAT"
              ? <p>We do not provide collection calendars for residents with communal bins. Call us on <a href="tel:01454 868000">01454 868000</a> for information about your collections.</p>
              :  <><a
                    href={routePDFURLNew}
                    style={{ textDecoration: "underline" }}
                    target="_parent"
                  >
                    View or print your collection calendar
                  </a>
                  </>
            } */}


            {(routeCode == "FLAT" && routeCode != "INT") ? (
              <p>We do not provide collection calendars for residents with communal bins.</p>
            ) : (routeCode != "FLAT" && routeCode == "INT")  ? (
              <p>Your calendar will be available to download after your extra black bin collection is complete.</p>
            ) : (routeCode == "INTERIM" )  ? (
              <p>Your calendar will be available to download after your extra black bin collection is complete.</p>  
            ) : (
              <>
                  <a
                    href={routePDFURLNew}
                    style={{ textDecoration: "underline" }}
                    target="_blank"
                  >
                    View or print your collection calendar
                  </a>
              </>
            )}


            {/* <div data-alertcolour="#00709e" class="wp-block-sgc-notice">
              <p>
                Some residents will get an extra one-off black bin collection which is not shown on the collection calendar. Check the waste services guide that you have received in the post for details.
              </p>
            </div> */}
            <br />
            <br />
          </div>
        </>
      )}



      {(_.isEmpty(GardenWasteSubs) || GardenWasteSubs == null ) && (
        <div id="noGwSubsFounds">
          <h2>Garden waste subscription</h2>
          <p>No garden waste subscriptions were found.</p>
          {/* <a
            style={{ textDecoration: "underline" }}
            href="https://www.southglos.gov.uk/form_newgreenwaste"
            target="_top"
          >
            Apply for a garden waste subscription
          </a>  */}
        </div>
      )}
      {
        (GardenWasteSubs != null && !_.isEmpty(GardenWasteSubs) ) && (    //
          <>
            <h2>Garden waste subscription</h2>
            <p>Garden waste subscription end date: <strong>{convertDateFormat(GardenWasteSubs)}</strong></p>       
          </>
        )
      }

      <br />
      <br />
      <button type="button" className="button button--close" onClick={ExitForm}>
        Close
      </button>
      <br />
      <br />
    </div>
  );
}

export default GWCollectionResults;
